import { HttpError } from 'utils/http';

/**
 * Ce que le candidat lit quand l'inscription échoue. Les messages du serveur sont en anglais et
 * techniques : on traduit par statut, sans jamais les afficher tels quels. Celui qui s'inscrit seul
 * n'a personne pour rattraper un échec muet ou cryptique.
 */
export type SignUpError =
    // Sur le champ email : c'est le seul que le serveur refuse.
    | 'invalid-email'
    // Messages globaux, au-dessus du bouton d'envoi.
    | 'captcha-refused'
    | 'too-many-attempts'
    | 'unavailable';

export const signUpErrorFor = (error: unknown): SignUpError => {
    if (!(error instanceof HttpError)) {
        // fetch rejette sans statut quand le serveur est injoignable.
        return 'unavailable';
    }

    switch (error.status) {
        case 400:
            return 'invalid-email';
        case 403:
            return 'captcha-refused';
        case 429:
            return 'too-many-attempts';
        default:
            return 'unavailable';
    }
};
